import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyers } from '../data/offer';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutes, setMinutes] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let cycleTimer: number;
    const show = () => {
      setIndex(prev => (prev + 1 + Math.floor(Math.random() * 3)) % buyers.length);
      setMinutes(1 + Math.floor(Math.random() * 9));
      setOpen(true);
      hideTimer = window.setTimeout(() => {
        setOpen(false);
        cycleTimer = window.setTimeout(show, GAP);
      }, VISIBLE_FOR);
    };
    cycleTimer = window.setTimeout(show, FIRST_DELAY);
    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(cycleTimer);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-[100px] left-3 right-3 z-50 sm:right-auto sm:left-5 sm:w-[360px]" aria-live="polite" data-id="element-36" data-mp="1164o26qe2u2c">
      <AnimatePresence data-id="element-37" data-mp="1fxn2w17iiik4">
        {open && !dismissed && <motion.div key={`${buyer.name}-${minutes}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-line bg-white p-3 pr-9 shadow-2xl" data-id="element-38" data-mp="1ay0p9qnrv0as">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-volt font-display text-xl font-extrabold text-white" data-id="element-39" data-mp="28k7qqros4cix">
              {buyer.name.charAt(0)}
            </div>
            <div className="min-w-0 text-sm leading-snug text-slate-700" data-id="element-40" data-mp="2aothi5er5heg">
              <p data-id="element-41" data-mp="2aqxkml4tucdo">
                <span className="font-bold text-ink" data-id="element-42" data-mp="2fne8rfc10qqr">{buyer.name}</span> from{' '}
                <span className="font-bold text-ink" data-id="element-43" data-mp="2fpha2vimq6as">{buyer.country}</span>
              </p>
              <p data-id="element-44" data-mp="2kkoanuglquvh">just purchased the HVAC Electrical Troubleshooting Blueprint™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-emerald-600" data-id="element-45" data-mp="2pl2gd5uqdsqc">
                <CheckCircle2Icon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-46" data-mp="1rzwnm2n9oqwr" /> Verified · {minutes} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-md p-1 text-slate-400 transition-colors duration-150 hover:text-slate-700" aria-label="Dismiss notification" data-id="element-47" data-mp="21wj7op7rrdxq">
              <XIcon className="h-4 w-4" data-id="element-48" data-mp="1e6oto4bprjbw" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}